import { useState } from 'react';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    try {
      const body = new URLSearchParams({ email });
      await fetch('https://readdy.ai/api/form/d7e88hlfi84lst2jvug0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      setSubmitted(true);
      setEmail('');
    } catch {
      setSubmitted(true);
    }
  };

  return (
    <footer className="bg-[#04090f] px-6 py-16">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-14">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src="https://static.readdy.ai/image/2063d56d77349d69e524f0264c628611/bee8d5fb7f0cfa528bf76460a88c5217.png"
              alt="PRODIFY"
              className="h-10 w-auto object-contain mb-4"
            />
            <p className="text-gray-400 text-sm leading-relaxed mb-5">
              Automotive business software built for South Africa. Streamline inventory, track vehicles, and grow faster.
            </p>
            <div className="flex gap-3">
              {[
                { icon: 'ri-facebook-fill', href: '#' },
                { icon: 'ri-linkedin-fill', href: '#' },
                { icon: 'ri-whatsapp-line', href: '#' },
                { icon: 'ri-twitter-x-line', href: '#' },
              ].map((s, i) => (
                <a
                  key={i}
                  href={s.href}
                  className="w-9 h-9 flex items-center justify-center bg-white/5 hover:bg-[#f97316]/20 border border-white/10 hover:border-[#f97316]/30 rounded-lg text-gray-400 hover:text-[#f97316] transition-all duration-200"
                >
                  <i className={`${s.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-5 uppercase tracking-wider">Product</h4>
            <ul className="space-y-3">
              {['Features', 'Pricing', 'Integrations', 'Mobile App', 'Changelog', 'API Docs'].map((link) => (
                <li key={link}>
                  <a href="#" className="text-gray-400 hover:text-[#f97316] text-sm transition-colors duration-200">{link}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-5 uppercase tracking-wider">Company</h4>
            <ul className="space-y-3">
              {['About PRODIFY', 'Blog', 'Case Studies', 'Partners', 'Careers', 'Contact Us'].map((link) => (
                <li key={link}>
                  <a href="#" className="text-gray-400 hover:text-[#f97316] text-sm transition-colors duration-200">{link}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-2 uppercase tracking-wider">Stay Updated</h4>
            <p className="text-gray-400 text-sm mb-4">Get product updates and automotive industry insights.</p>
            {submitted ? (
              <div className="flex items-center gap-2 text-green-400 text-sm">
                <i className="ri-checkbox-circle-line"></i>
                Thanks! You&apos;re subscribed.
              </div>
            ) : (
              <form data-readdy-form onSubmit={handleSubscribe} className="flex gap-2">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  required
                  className="flex-1 px-4 py-2.5 bg-white/5 border border-white/10 rounded-lg text-white text-sm placeholder-gray-500 focus:outline-none focus:border-[#f97316]/50 min-w-0"
                />
                <button
                  type="submit"
                  className="px-4 py-2.5 bg-[#f97316] hover:bg-[#ea6c0a] text-white rounded-lg text-sm font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-send-plane-line"></i>
                </button>
              </form>
            )}

            <div className="mt-5 p-3 bg-white/5 border border-white/10 rounded-xl">
              <div className="flex items-center gap-2 mb-1">
                <i className="ri-map-pin-line text-[#f97316] text-sm"></i>
                <span className="text-white text-xs font-semibold">South Africa</span>
              </div>
              <p className="text-gray-500 text-xs">Johannesburg | Cape Town | Durban</p>
              <p className="text-gray-500 text-xs mt-1">support@prodify.co.za</p>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-xs">
            © 2026 PRODIFY. All rights reserved. Powered by South African innovation.
          </p>
          <div className="flex flex-wrap gap-5 justify-center">
            {['Privacy Policy', 'Terms of Service', 'POPIA Compliance', 'Cookie Policy'].map((l) => (
              <a key={l} href="#" className="text-gray-500 hover:text-gray-300 text-xs transition-colors">{l}</a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
